<template>
  <div class="chat-container w-100 position-relative bg-light-page h-auto" style="min-height: 100vh;margin-bottom: -20px">
    <div id="hotel-history"></div>
    <div class="position-relative z-index-1028">
      <div class="row no-gutters justify-content-center">
        <div class="fixed-top d-block nav-bottom">
          <div class="custom-container-fluid px-0">
            <div class="row justify-content-center no-gutters">
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                <div class="bg-white pb-1 delay" :class="{'box-shadow-bottom':scrollPosition > 30}">
                  <div class="container px-4 w-100 pt-2 pb-3">
                    <div class="row no-gutters pt-1 m-0 w-100">
                      <div class="col-12">
                        <p class="mb-0 body-1-1 text-26">{{$t('hotel.concierge.order')}}</p>
                        <p class="mb-0 pb-0 body-3-3-1">{{$t('hotel.concierge.all-your-order-and-request')}}</p>
                      </div>
                      <!-- <div class="col-1 text-right">
                        <router-link :to="'/'+getMerchant().code+'/concierge/history'">
                          <img src="../../../assets/img/icon/menu/icn_calendar__inactive.png" width="19" class="mt-2 cursor-pointer position-relative" style="top: 1px;right: 1px;">
                        </router-link>
                      </div> -->
                    </div>
                  </div>
                  <div class="container px-4 pb-3 bg-white">
                    <div class="row">
                      <div class="col-6">
                        <p class="body-2-2 text-14 mb-0 position-relative" style="top: 2px">{{$t('hotel.concierge.tap-to-see-detail')}}</p>
                      </div>
                      <div class="col-6 text-right">
                        <p class="body-3-1 mb-0 text-14 d-inline-block mr-1 cursor-pointer" @click="is_filter = !is_filter">{{$t('hotel.concierge.filter')}}</p>
                        <div class="d-inline-block delay" :class="{'rotate-90':is_filter}">
                          <i class="simple-icon-equalizer p-2 rounded-100 cursor-pointer bg-light-page border" @click="is_filter = !is_filter"></i>
                        </div>
                      </div>
                      <transition name="fade">
                        <div class="col-12 mt-2" v-if="is_filter">
                          <div class="row slim-grid-row">
                            <div class="col-12 text-center pt-5" v-if="is_load_filter">
                              <div class="my-5 text-center">
                                <loader />
                              </div>
                            </div>
                            <template v-else>
                              <div class="my-4" v-if="filter_error != ''">
                                <ErrorMessage :message="filter_error" />
                              </div>
                              <template v-else>
                                <div class="col-12 mb-2">
                                  <p class="mb-1 body-2-2 text-12">{{$t('hotel.concierge.service')}}</p>
                                  <select :disabled="is_load" v-model="module.selected" class="w-100 border bg-white body-2-2 p-2 rounded-3">
                                    <!-- <option>All Service</option> -->
                                    <option v-for="module_item in module.list" :value="module_item">{{module_item.name}}</option>
                                  </select>
                                </div>
                                <div class="col-6 mb-2">
                                  <p class="mb-1 body-2-2 text-12">{{$t('hotel.concierge.status')}}</p>
                                  <select :disabled="is_load" v-model="status.selected" class="w-100 border bg-white body-2-2 p-2 rounded-3">
                                    <option v-for="status_item in status.list" :value="status_item">{{status_item.name}}</option>
                                  </select>
                                </div>
                                <div class="col-6 mb-2">
                                  <p class="mb-1 body-2-2 text-12">{{$t('hotel.concierge.time')}}</p>
                                  <select :disabled="is_load" v-model="time_order.selected" class="w-100 border bg-white body-2-2 p-2 rounded-3">
                                    <option v-for="time in time_order.list" :value="time">{{time.name}}</option>
                                  </select>
                                </div>
                              </template>
                            </template>
                          </div>
                        </div>
                      </transition>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="is_filter" style="height: 279px;"></div>
    <div v-else style="height: 130px;"></div>
    <div class="container p-4 bg-light-page">
      <div v-if="is_load" class="w-100 py-4 text-center">
        <loader />
      </div>
      <template v-else>
        <ErrorMessage v-if="error != ''" :message="error" />
        <template v-else>
          <template v-for= "item in order_list">
            <menuHistory :data="item" @selectDetail='toggleDetail'></menuHistory>
          </template>
          <!-- PAGINATION -->
          <div v-if="order_list.length > 0 && pagination.last_page > 1" class="overflow-auto mx-auto text-center py-3">
            <b-pagination
              class="d-inline-block"
              v-model="pagination.current_page"
              :total-rows="pagination.total"
              :per-page="10"
            ></b-pagination>
          </div>
          <template v-if="order_list.length == 0">
            <div class="container px-5 pt-3 text-center">
              <img src="../../../assets/img/icon/404.png" width="150" class="text-center">
              <p class="mb-0 mt-3 body-2-2 font-semibold">{{$t('hotel.concierge.no-order-desc.order')}}</p>
            </div>
          </template>
        </template>
      </template>
    </div>
    <!-- detail -->
    <transition name="fade">
      <template v-if="trx_selected.id != ''">
        <div class="position-relative" style="z-index: 1039">
          <div class="row no-gutters justify-content-center">
            <div class="fixed-bottom d-block nav-bottom" style="bottom:0%;top: 0">
              <div class="custom-container-fluid px-0">
                <div class="row justify-content-center no-gutters">
                  <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                    <div class="bg-white">
                      <div class="w-100 popup-full">
                        <div class="px-4 pt-4">
                          <div class="row">
                            <div class="col-3 align-self-center">
                              <img src="../../../assets/img/icon/cancel.png" class="p-2 rounded-3 bg-back cursor-pointer" width="33" @click="toggleDetail('')" style="z-index: 1038">
                            </div>
                            <div class="col-9 align-self-center">
                              <p class="mb-1 body-3-3 text-16 font-bold">{{$t('hotel.concierge.order-detail')}}</p>
                            </div>
                          </div>
                        </div>
                        <div class="my-4">
                          <historyDetail :trx_id="trx_selected.id" :type="trx_selected.type" ></historyDetail>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </transition>
    <bottom-navbar></bottom-navbar>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex';
  import {get} from '@/services/index.js';
  import moment from 'moment'
  import historyDetail from '@/components/hotel/concierge/general/historyDetail'
  import menuHistory from '@/components/hotel/concierge/general/menuHistory'
  import BottomNavbar from '@/components/hotel/BottomNavbar';

  export default{
    components: {
      BottomNavbar,
      menuHistory,
      historyDetail
    },
    metaInfo(){
      return {
        title: 'Order History',
        titleTemplate: this.getMetaTitleTemplate()
      }
    },
    data() {
      return {
        scrollPosition: null,
        is_filter: false,
        is_load_filter: false,
        filter_error: '',
        module:{
          list: [],
          selected: {}
        },
        status:{
          list: [
            {
              id: 'ALL',
              name : this.$t('hotel.concierge.all-status')
            },
            {
              id: 'PENDING',
              name : this.$t('hotel.concierge.waiting')
            },
            {
              id: 'ONPROGRESS',
              name : this.$t('hotel.concierge.on-progress')
            },
            {
              id: 'COMPLETE',
              name : this.$t('hotel.concierge.complete')
            },
            // {
            //   id: 'CANCELLED',
            //   name : 'Cancelled'
            // },
          ],
          selected:{
            id: 'ALL',
            name : this.$t('hotel.concierge.all-status')
          }
        },
        time_order:{
          list: [
            {
              id: 'ASC',
              name: this.$t('hotel.concierge.latest')
            },
            {
              id: 'DESC',
              name: this.$t('hotel.concierge.earliest')
            }
          ],
          selected: {
            id: 'ASC',
            name: this.$t('hotel.concierge.latest')
          }
        },
        stay_date:{
          checkin: null,
          checkout: null
        },
        is_load: true,
        order_list: [],
        error: '',
        pagination:{
          current_page: 1,
          total: 1,
          last_page: 1
        },
        trx_selected:{
          id: '',
          type: ''
        }
      }
    },
    computed:{
      filter(){
        let data = {
          module: this.module.selected,
          status: this.status.selected,
          time_order: this.time_order.selected
        }
        return data
      },
      current_page(){
        return this.pagination.current_page
      },
      validation_status(){
        let display = ''
        if (this.status.selected.id != 'PENDING' && this.status.selected.id != 'ONPROGRESS') {
          display = true
        }else{
          display = false
        }
        return display
      }
    },
    watch:{
      filter:{
        deep: true,
        handler(){
          this.pagination.current_page = 1
          this.loadOrderList()
        }
      },
      current_page(){
        if(!this.is_load){
          this.loadOrderList()
        }
      }
    },
    mounted() {
      if (this.$route.query.reload){
        this.$router.replace(
          {
            query: {
            }
          }
        )
        window.location.reload();
      }else{
        window.addEventListener('scroll', this.updateScroll);
        document.getElementById('hotel-history').scrollIntoView({
          behavior: 'smooth'
        });
        this.loadModuleList().then(()=>{
          if(!this.is_load){
            this.loadOrderList()
          }
        })
      } 
    },
    methods: {
      ...mapGetters(['getMerchant','getConciergeAuth','getMetaTitleTemplate']),
      updateScroll() {
        this.scrollPosition = window.scrollY
      },
      isFilter(){
        this.is_filter = !this.is_filter
      },
      xScroll(type, id) {
        let content = document.querySelector("#" + id);
        if (type == 'left') {
          content.scrollLeft -= 80;
        } else {
          content.scrollLeft += 80;
        }
      },
      toggleDetail(data){
        this.trx_selected = data == '' ? {
          id: '',
          type: ''
        } : data
      },
      changeStatus(status){
        this.status.selected = this.status.list.find(x=>x.id == status)
      },
      loadModuleList(){
        return new Promise(done=>{
          this.is_load_filter = true
          get("CONCIERGE","concierge-menu-service-product",{
            merchant_id: this.getMerchant().id
          }).then(response=>{
            let res = response.data
            if(res.success){
              this.module.list.push({
                id: 'all',
                name: this.$t('hotel.concierge.all-services')
              })
              for(let mod of res.data){
                this.module.list.push(mod)
              }
              this.module.selected = this.module.list[0]
            }else{
              this.filter_error = res.message
            }
            this.is_load_filter = false
            done(true)
          })
        })
      },
      loadOrderList(){
        this.is_filter = false
        this.is_load = true
        let params = {
          status: this.status.selected.id,
          order_type: this.time_order.selected.id,
          datetime_type: 'NO_USE_FILTER_DATE',
          start_datetime: moment().format("YYYY-MM-DD")+" 00:00:00",
          end_datetime: moment().format("YYYY-MM-DD")+" 00:00:00",
          page_size: 10,
          page: this.pagination.current_page,
          pms_detail_id: this.getConciergeAuth().detail_id,
          folio_no: this.getConciergeAuth().folio,
          merchant_id: this.getMerchant().id,
          module_id: this.module.selected.id == 'all' ? '' : this.module.selected.id 
        }

        get("CONCIERGE","tx-history",params,"concierge_pin").then(response=>{
          let res = response.data
          if(res.success == false){
            this.error = res.message
          }else{
            this.order_list = res.data
            this.pagination = {
              current_page: res.current_page,
              total: res.total,
              last_page: res.last_page
            }
          }
          this.is_load = false
        })
      }
    },
  }
</script>
<style scoped>

.h-auto{
  height: auto!important;
}

.left-0-d{
  left: 0!important
}

@media screen and (max-width: 655px) {
  .mobile-none{
    display: none !important;
  }
} 
</style>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/Order.vue